var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelpInfo24Bold = function SvgHelpInfo24Bold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12.047c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10-10-4.477-10-10Zm7.781-5.723A4 4 0 0 0 8 9.652v.395a1 1 0 1 0 2 0v-.395a2 2 0 0 1 3.11-1.664l.175.117a1.605 1.605 0 0 1-.89 2.942h-.122c-.703 0-1.273.57-1.273 1.273v1.727a1 1 0 1 0 2 0v-1.05a3.606 3.606 0 0 0 1.394-6.556l-.175-.117a4 4 0 0 0-4.438 0ZM12 18.047a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    fill: "currentColor"
  })));
};
export default SvgHelpInfo24Bold;